import {createContext, useEffect, useReducer, useContext, useRef} from 'react';
// import jwtDecode from 'jwt-decode';

import {ACCOUNT_INITIALISE, LOGIN, LOGOUT, IMGPERFIL, PRIMEIRO_ACESSO, POSSUI_EMPRESAS, POSSUI_NOTAS, USER64, MODULOATUAL} from '../store/actions';
import axios from '../services/axios';
import accountReducer from '../store/accountReducer';
import Loader from '../components/Loader/Loader';
import {ConfigContext} from './ConfigContext';
import {encode as base64_encode} from 'base-64';
import {CheckSessaoUser} from '../components/Utilitarios/Funcoes';
import {INTERVALO_CHECK_SESSAO} from '../config/constant';

const initialState = {
  isLoggedIn: false,
  isInitialised: false,
  user: null,
};

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
    return false;
  }

  const decoded = wt_decode(serviceToken);
  return decoded.exp > Date.now() / 1000;
};

const wt_decode = (token) => {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

const setSession = (serviceToken) => {
  if (serviceToken) {
    localStorage.setItem('serviceToken', serviceToken);
    axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
  } else {
    localStorage.removeItem('serviceToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

const LoginContext = createContext({
  ...initialState,
  login: () => Promise.resolve(),
  loginVariasEmpresas: () => Promise.resolve(),
  logout: () => {},
});

export const LoginProvider = ({children}) => {
  const [state, dispatch] = useReducer(accountReducer, initialState);
  const configContext = useContext(ConfigContext);
  const ultimaInteracaoRef = useRef(0);

  const login = async (email, password, lembrar, token, dataGoogle, boolViaGoogle) => {
    const response = await axios.post('/api/account/', {dest: 'login', email, password, lembrar, token, dataGoogle, boolViaGoogle});
    const {serviceToken, user} = response.data;

    if (response.data.message === 'ok') {
      setSession(serviceToken);
      dispatch({
        type: LOGIN,
        payload: {
          user,
        },
      });

      configContext.dispatch({type: USER64, user64: base64_encode(response.data.user.uId)});
      configContext.dispatch({type: IMGPERFIL, imgPerfil: response.data.user.imgPerfil});
      configContext.dispatch({type: PRIMEIRO_ACESSO, primeiroAcesso: response.data.primeiroAcesso});
      configContext.dispatch({type: POSSUI_EMPRESAS, possuiEmpresas: response.data.possuiEmpresas});
      configContext.dispatch({ type: POSSUI_NOTAS, possuiNotas: response.data.possuiNotas });
      

      if (localStorage.getItem('moduloAtual') === null) {
        configContext.dispatch({ type: MODULOATUAL, moduloAtual: response.data.plano === '4' ? 1 : 0 });      
        if (response.data.plano === '4') {
          localStorage.setItem('moduloAtual', 1);
        } else {
          localStorage.setItem('moduloAtual', 0);
        }
      } else {
        const moduloAtual = Number(localStorage.getItem('moduloAtual'));
        configContext.dispatch({ type: MODULOATUAL, moduloAtual: moduloAtual });
      }
    }
    return response.data;
  };

  const loginVariasEmpresas = async (dataPost) => {
    const response = await axios.post('/api/account/', {dest: 'acessoVarias', dataPost});
    const {serviceToken, user} = response.data;

    if (response.data.message === 'ok') {
      setSession(serviceToken);
      dispatch({
        type: LOGIN,
        payload: {
          user,
        },
      });
    }
    return response.data;
  };

  const cadastrar = async (dados) => {
    
    
    const response = await axios.post('/api/account/', {dest: 'cadastrar', dados});
    
    
    const {serviceToken, user} = response.data;
    if (response.data.message === 'ok') {
      setSession(serviceToken);
      dispatch({
        type: LOGIN,
        payload: {
          user,
        },
      });

      configContext.dispatch({type: USER64, user64: base64_encode(response.data.user.uId)});
      configContext.dispatch({type: IMGPERFIL, imgPerfil: response.data.user.imgPerfil});
      configContext.dispatch({type: PRIMEIRO_ACESSO, primeiroAcesso: response.data.primeiroAcesso});
      configContext.dispatch({type: POSSUI_EMPRESAS, possuiEmpresas: response.data.possuiEmpresas});
      configContext.dispatch({type: POSSUI_NOTAS, possuiNotas: response.data.possuiNotas});
    }
    return response.data;
    //return data;
  };

  const logout = () => {
    setSession(null);
    // localStorage.clear();
    sessionStorage.clear();
    dispatch({type: LOGOUT});
  };

  useEffect(() => {
    const init = async () => {
      try {
        const serviceToken = window.localStorage.getItem('serviceToken');
        const sessionData = sessionStorage.getItem('ddesp');
        if (serviceToken && sessionData) {
          setSession(serviceToken);

          const response = await axios.get('/api/account/', {dest: 'me'});
          const {user} = response.data;
          dispatch({
            type: ACCOUNT_INITIALISE,
            payload: {
              isLoggedIn: true,
              user: user,
            },
          });
        } else {
          dispatch({
            type: ACCOUNT_INITIALISE,
            payload: {
              isLoggedIn: false,
              user: null,
            },
          });
        }
      } catch (err) {
        dispatch({
          type: ACCOUNT_INITIALISE,
          payload: {
            isLoggedIn: false,
            user: null,
          },
        });
      }
    };

    init();
  }, []);

  useEffect(() => {
    if (!state.isLoggedIn) return;
    const id = setInterval(() => { CheckSessaoUser(); }, INTERVALO_CHECK_SESSAO);
    return () => clearInterval(id);
  }, [state.isLoggedIn]);

  useEffect(() => {
    if (!state.isLoggedIn) return;
    return undefined;
  }, [state.isLoggedIn]);

  if (!state.isInitialised) {
    return <Loader />;
  }
  return <LoginContext.Provider value={{...state, login, loginVariasEmpresas, cadastrar, logout}}>{children}</LoginContext.Provider>;
};

export default LoginContext;
